import { render, staticRenderFns } from "./AccClass.vue?vue&type=template&id=9513371e&scoped=true"
import script from "./AccClass.vue?vue&type=script&lang=js"
export * from "./AccClass.vue?vue&type=script&lang=js"
import style0 from "./AccClass.vue?vue&type=style&index=0&id=9513371e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9513371e",
  null
  
)

export default component.exports